import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export const SvgIconWrapper = styled(SVG)<{
  fillColor: string;
  isRtl: boolean;
}>`
  display: block;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  ${(props) => props.isRtl && `transform: scaleX(-1);`};

  path,
  rect,
  circle {
    fill: ${(props) => props.fillColor};
  }
`;
